module.exports = __webpack_public_path__ + "media/images/tl/banner/en-2-dark-aa3c3cc48deef98a747251365b273ffd.jpg";